export default "__VITE_ASSET__DiLUqS1F__"